// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-xJ2","colBig":"styles_colBig__1vrsY","colSmall":"styles_colSmall__3Iac-","shopifyNameWrapper":"styles_shopifyNameWrapper__2Jcx0"};